import React from "react";
import { useNavigate } from "react-router-dom";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { t } from "i18next";
import { Trans } from "react-i18next";
const listOne = [
  {
    id: 1,
    data: t("terms_and_conditions.definitions.definitions_list.account"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.definitions.definitions_list.company"),
  },
  {
    id: 3,
    data: t("terms_and_conditions.definitions.definitions_list.content"),
  },
  {
    id: 4,
    data: t("terms_and_conditions.definitions.definitions_list.device"),
  },
  {
    id: 5,
    data: t("terms_and_conditions.definitions.definitions_list.eula"),
  },
  {
    id: 6,
    data: t(
      "terms_and_conditions.definitions.definitions_list.intellectual_property_rights"
    ),
  },
  {
    id: 7,
    data: t("terms_and_conditions.definitions.definitions_list.subscription"),
  },
  {
    id: 8,
    data: t(
      "terms_and_conditions.definitions.definitions_list.user_generated_content"
    ),
  },
  {
    id: 9,
    data: t("terms_and_conditions.definitions.definitions_list.you"),
  },
];

const listTwo = [
  {
    id: 1,
    data: t("terms_and_conditions.changes_of_eula.list.changes_intro"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.changes_of_eula.list.changes_effective"),
  },
];

const listThree = [
  {
    id: 1,
    data: t("terms_and_conditions.device.list.use_non_owned_device"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.device.list.access_to_non_owned_device"),
  },
  {
    id: 3,
    data: t("terms_and_conditions.device.list.responsibility"),
  },
  {
    id: 4,
    data: t("terms_and_conditions.device.list.removal"),
  },
];

const listFour = [
  {
    id: 1,
    data: t("terms_and_conditions.capacity_and_age.list.over_16"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.capacity_and_age.list.between_16_18"),
  },
];

const listFive = [
  {
    id: 1,
    data: t(
      "terms_and_conditions.intellectual_property.list.license_grant_and_webapp_use_terms"
    ),
  },
  {
    id: 2,
    data: t(
      "terms_and_conditions.intellectual_property.list.intellectual_property_rights_and_reservation_of_rights"
    ),
  },
  {
    id: 3,
    data: t(
      "terms_and_conditions.intellectual_property.list.restrictions_on_transferring_rights_to_webapp"
    ),
  },
  {
    id: 4,
    data: t(
      "terms_and_conditions.intellectual_property.list.restrictions_on_network_distribution_and_access"
    ),
  },
  {
    id: 5,
    data: t(
      "terms_and_conditions.intellectual_property.list.prohibitions_on_interfering_with_webapp_functionality"
    ),
  },
  {
    id: 6,
    data: t(
      "terms_and_conditions.intellectual_property.list.prohibitions_on_decompiling_and_reverse_engineering"
    ),
  },
  {
    id: 7,
    data: t(
      "terms_and_conditions.intellectual_property.list.prohibitions_on_unlawful_use_and_malicious_activity"
    ),
  },
];

const listSix = [
  {
    id: 1,
    data: t(
      "terms_and_conditions.subscription_and_trial_period.list.subscription_basis_and_fee_variation"
    ),
  },
  {
    id: 2,
    data: t(
      "terms_and_conditions.subscription_and_trial_period.list.automatic_renewal_and_account_charge"
    ),
  },
  {
    id: 3,
    data: t(
      "terms_and_conditions.subscription_and_trial_period.list.cancellation_of_subscription_renewal"
    ),
  },
  {
    id: 4,
    data: t(
      "terms_and_conditions.subscription_and_trial_period.list.manual_cancellation_required"
    ),
  },
  {
    id: 5,
    data: t(
      "terms_and_conditions.subscription_and_trial_period.list.free_trial_period_and_auto_conversion"
    ),
  },
];

const listSeven = [
  {
    id: 1,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.subscription_costs_availability"
    ),
  },
  {
    id: 2,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.payment_processing_by_platform_administrator"
    ),
  },
  {
    id: 3,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.no_access_to_payment_information"
    ),
  },
  {
    id: 4,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.questions_on_payment_processing"
    ),
  },
  {
    id: 5,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.account_charge_timing"
    ),
  },
  {
    id: 6,
    data: t(
      "terms_and_conditions.fees_and_purchase_terms.list.no_refunds_and_immediate_content_access"
    ),
  },
];

const listEight = [
  {
    id: 1,
    data: t(
      "terms_and_conditions.user_generated_content.list.exposure_to_objectionable_content"
    ),
  },
  {
    id: 2,
    data: t(
      "terms_and_conditions.user_generated_content.list.modifications_and_censorship"
    ),
  },
  {
    id: 3,
    data: t(
      "terms_and_conditions.user_generated_content.list.handling_objectionable_content"
    ),
  },
  {
    id: 4,
    data: t(
      "terms_and_conditions.user_generated_content.list.company_disclaimer"
    ),
  },
];

const listNine = [
  {
    id: 1,
    data: t(
      "terms_and_conditions.disclaimer.list.general_disclaimer_of_warranties"
    ),
  },
  {
    id: 2,
    data: t("terms_and_conditions.disclaimer.list.content_provided_as_is"),
  },
  {
    id: 3,
    data: t(
      "terms_and_conditions.disclaimer.list.no_warranty_on_specifics.title"
    ),
  },
  {
    id: "a",
    data: t("terms_and_conditions.disclaimer.list.no_warranty_on_specifics.a"),
  },
  {
    id: "b",
    data: t("terms_and_conditions.disclaimer.list.no_warranty_on_specifics.b"),
  },
  {
    id: "c",
    data: t("terms_and_conditions.disclaimer.list.no_warranty_on_specifics.c"),
  },
  {
    id: "d",
    data: t("terms_and_conditions.disclaimer.list.no_warranty_on_specifics.d"),
  },
  {
    id: 4,
    data: t("terms_and_conditions.disclaimer.list.limitation_of_liability"),
  },
];

const listTen = [
  {
    id: 1,
    data: t("terms_and_conditions.transfer_of_rights.list.transfer_by_company"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.transfer_of_rights.list.transfer_by_user"),
  },
];

const listTwelve = [
  {
    id: 1,
    data: t("terms_and_conditions.miscellaneous.list.separation_of_paragraphs"),
  },
  {
    id: 2,
    data: t("terms_and_conditions.miscellaneous.list.delay_in_enforcement"),
  },
  {
    id: 3,
    data: t("terms_and_conditions.miscellaneous.list.governing_law"),
  },
  {
    id: 4,
    data: t("terms_and_conditions.miscellaneous.list.dispute_resolution"),
  },
];

const Terms = () => {
  const navigate = useNavigate();

  return (
    <MobileViewLayout>
      <div className="py-3">
        <div
          className="text-center d-flex flex-column pb-4"
          style={{ minHeight: "100dvh" }}
        >
          <div
            style={{ position: "relative" }}
            className="d-flex justify-content-center border border-black border-top-0 border-start-0 border-end-0 pb-3"
          >
            <div>
              <div
                style={{
                  position: "absolute",
                  left: "15px",
                  cursor: "pointer",
                }}
              >
                <svg
                  onClick={() => navigate(-1)}
                  style={{ borderRadius: "50%", border: "1px solid #000" }}
                  width="26px"
                  height="26px"
                  viewBox="0 0 1024 1024"
                  fill="#000000"
                  className="icon"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" />
                </svg>
              </div>
              <h4 className="m-0 p-0">{t("terms_and_conditions.title")}</h4>
            </div>
          </div>
          <div
            style={{ textAlign: "left" }}
            className="d-flex flex-column px-4 mt-4"
          >
            <p>{t("terms_and_conditions.intro")}</p>
            <h3 className="mt-2">
              {t("terms_and_conditions.definitions.title")}
            </h3>
            <p>{t("terms_and_conditions.definitions.description")}</p>
            {listOne.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.changes_of_eula.title")}
            </h3>
            {listTwo.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">{t("terms_and_conditions.device.title")}</h3>
            {listThree.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.capacity_and_age.title")}
            </h3>
            {listFour.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.intellectual_property.title")}
            </h3>
            {listFive.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.subscription_and_trial_period.title")}
            </h3>
            {listSix.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.fees_and_purchase_terms.title")}
            </h3>
            {listSeven.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.user_generated_content.title")}
            </h3>
            {listEight.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.disclaimer.title")}
            </h3>
            {listNine.map((d) => (
              <p key={d.id}>
                {d?.id}
                {typeof d?.id === "number" ? "." : ")"} {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.transfer_of_rights.title")}
            </h3>
            {listTen.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <h3 className="mt-2">
              {t("terms_and_conditions.termination_of_rights.title")}
            </h3>
            <p>
              1.{" "}
              {t(
                "terms_and_conditions.termination_of_rights.list.termination_for_breach"
              )}
            </p>
            <p>
              2.{" "}
              {t(
                "terms_and_conditions.termination_of_rights.list.actions_upon_termination.title"
              )}
            </p>
            <p>
              a){" "}
              {t(
                "terms_and_conditions.termination_of_rights.list.actions_upon_termination.a"
              )}
            </p>
            <p>
              b){" "}
              {t(
                "terms_and_conditions.termination_of_rights.list.actions_upon_termination.b"
              )}
            </p>
            <h3 className="mt-2">
              {t("terms_and_conditions.miscellaneous.title")}
            </h3>
            {listTwelve.map((d) => (
              <p key={d.id}>
                {d?.id}. {d?.data}
              </p>
            ))}
            <p>
              {t(
                "terms_and_conditions.miscellaneous.list.number_of_arbitrators"
              )}
            </p>
            <p>
              {t(
                "terms_and_conditions.miscellaneous.list.place_of_arbitrators"
              )}
            </p>
            <p>
              {t(
                "terms_and_conditions.miscellaneous.list.language_of_arbitrators"
              )}
            </p>
            <p>{t("terms_and_conditions.miscellaneous.list.expense")}</p>
            <p>
              5.{" "}
              <Trans
                i18nKey={"terms_and_conditions.miscellaneous.list.support"}
                components={{
                  tag: <a href="mailto:support@freelanz.app" />,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default Terms;
